import BaseEntity from '../baseclasses/BaseEntity'
export class EquipmentCategory extends BaseEntity {
    ID?: number;
    Name?: string;
}

export default EquipmentCategory;